export default __webpack_public_path__ + "static/media/product30_slides.f88a5f07.webp";